import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import API_URL from "../config";
import Loading from "../components/Loading";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

const UserByTrainer = () => {
  const { trainerId } = useParams();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const fetchUsers = async () => {
    try {
      const response = await fetch(`${API_URL}/auth/trainer/${trainerId}`);
      if (!response.ok) {
        throw new Error("Failed to fetch users");
      }
      const data = await response.json();
      setUsers(data);
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, [trainerId]);

  const filteredData = users || [];
  const totalPages = Math.max(1, Math.ceil(filteredData.length / itemsPerPage));

  const paginatedData = filteredData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const goToNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage((prev) => prev + 1);
    }
  };

  const goToPrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prev) => prev - 1);
    }
  };

  return (
    <div className="userManagementContainer">
      <h2>User List for Trainer {trainerId}</h2>
      <div className="table-container">
        {loading ? (
          <Loading />
        ) : (
          <>
            <table className="custom-table">
              <thead>
                <tr>
                  <th>Member ID</th>
                  <th>Name</th>
                  <th>Phone Number</th>
                  <th>Mail ID</th>
                  <th>Renewal Status</th>
                </tr>
              </thead>
              <tbody>
                {paginatedData.length > 0 ? (
                  paginatedData.map((item) => {
                    const currentDate = new Date();
                    const renewalExpiryDate = new Date(item.renewalExpiryDate);
                    const isExpired = currentDate > renewalExpiryDate;

                    return (
                      <tr key={item.memberId}>
                        <td>{item.memberId}</td>
                        <td>{item.fullName}</td>
                        <td>{item.phoneNo}</td>
                        <td>{item.email}</td>
                        <td
                          className={
                            isExpired ? "status-expired" : "status-active"
                          }
                        >
                          <span className="status-indicator"></span>
                          {isExpired ? "Expired" : "Active"}
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td
                      colSpan="5"
                      style={{
                        textAlign: "center",
                        margin: "10px 0",
                        fontSize: 16,
                        color: "#ff0000",
                      }}
                      className="no-data"
                    >
                      No users found!
                    </td>
                  </tr>
                )}
              </tbody>
            </table>

            <div className="pagination">
              <button
                className="pagination-btn"
                onClick={goToPrevPage}
                disabled={currentPage === 1}
              >
                <FaChevronLeft />
              </button>
              <span className="pagination-text">
                Page {currentPage} of {totalPages}
              </span>
              <button
                className="pagination-btn"
                onClick={goToNextPage}
                disabled={currentPage >= totalPages}
              >
                <FaChevronRight />
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default UserByTrainer;
